import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import { IKeyNumbers } from "@/types/page";
import adminAxios from "@/lib/axios";

export async function createKeyNumbers(payload: Partial<IKeyNumbers>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.KEY_NUMBERS.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateKeyNumbers(id: number, payload: Partial<IKeyNumbers>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.KEY_NUMBERS.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
